import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Configuration } from 'msal';
import { MsalGuardConfiguration } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { FlatfileService } from './services/flatfile.service';
import { InteractionType } from '@azure/msal-browser';


@Injectable({
  providedIn: 'root'
})
export class SettingsProvider {
  // MSALAngularConfig(isIE: boolean): MsalGuardConfiguration {
  //   throw new Error("Method not implemented.");
  // }
  private config: any;

  constructor(private readonly handler: HttpBackend) { }

  public async loadConfig() {
    this.config = {
      'clientId': environment.clientId,
      'authority': environment.authority,
      'validateAuthority': true,
      'redirectUri': environment.webAppUrl,
      'postLogoutRedirectUri': environment.webAppUrl,
      'navigateToLoginRequestUrl': true
    };
  }

  public get configuration(): any {
    return this.config;
  }

  public MSALConfig(isIE): Configuration {
    this.config = {
      'clientId': environment.clientId,
      'authority': environment.authority,
      'validateAuthority': true,
      'redirectUri': environment.webAppUrl,
      'postLogoutRedirectUri': environment.webAppUrl,
      'navigateToLoginRequestUrl': true
    };
    return {
      auth: this.config,
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // set to true for IE 11
      },
    };
  }

  // public MSALAngularConfig(): MsalAngularConfiguration {
  //  return {
  //    //popUp: false, // !isIE, TODO:
  //    consentScopes: [
  //      environment.clientId + '/.default'
  //    ],
  //    unprotectedResources: ['https://www.microsoft.com/en-us/'],
  //    'protectedResourceMap': new Map<string, Array<string> | null>([
  //      [environment.apiUrl, [environment.clientId + '/.default']],
  //      [environment.usApiUrl, [environment.clientId + '/.default']],
  //      [environment.apacApiUrl, [environment.clientId + '/.default']],
  //      ]),
  //      extraQueryParameters: {
  //        prompt: 'select_account',
  //      },

    
 
  //     // interactionType: InteractionType.Redirect,
  //     // authRequest: (authService, state) => {
  //     //   return {
  //     //     scopes: state.root.url.some(x => x.path === 'calendar')
  //     //       ? ['user.read', '	Calendars.Read']
  //     //       : ['user.read']
  //     //   }
  //     // },
  //     // loginFailedRoute: "./login-failed"
    

  //  };
  // }

}
